module.exports = __webpack_public_path__ + "57ca1a2085d82f0574e3ef740b9a5ead.gif";